module.exports = __webpack_public_path__ + "static/media/tablet-android-alt.4efcc14b.svg";